module.exports = "https://cdn.hellotech.com/client-assets/HT-logo-SHP_125e52c32763a7e6575a01e5dcc094ef.png";